export const AEM_SECTION_TYPES = {
    AUTO_DELIVERY: 'AutoDelivery',
    HIGHLIGHTS: 'Highlights',
    FOR_YOU: 'ForYou',
    TOP_BANNER: 'TopBanner',
    YOUR_USUAL: 'YourUsual',
    YOUR_DEVICES: 'YourDevices',
    SHOP_BY_PRODUCT: 'ShopByProduct',
    DCX_LOYALTY: 'DcxLoyalty',
    CLUB_PLUS: 'ClubPlus',
} as const;

export type AemSectionType = (typeof AEM_SECTION_TYPES)[keyof typeof AEM_SECTION_TYPES];
